import React from "react";

export interface ILinkContext {
  wrapper?: React.ElementType;
}

const LinkContext = React.createContext<ILinkContext>({});

export default LinkContext;
